import { Box } from '@mui/material';
import { colors, Icons } from '../../../../../../packages';
import { useStyles } from './TopbarView.styles';

const TopbarView = ({ publisher, screen, hidden, style, showPermissionIcons }) => {
  const classes = useStyles();
  return (
    <Box position="relative" visibility={hidden ? 'hidden' : 'visible'} sx={style}>
      <Box className={classes.container}>
        <Box display="flex" gap="30px">
          <Box className={classes.thumbnail} sx={{ position: 'relative' }}>
            {publisher}
            {showPermissionIcons && (
              <Box className={classes.noPermissionsOverlay}>
                <Box display="flex" flex={1} justifyContent="space-evenly" alignItems="center">
                  <Icons glyph="camera-off" size={32} />
                  <div
                    style={{
                      width: '1px',
                      height: '7rem',
                      backgroundColor: colors.destructive100,
                    }}
                  />
                  <Icons glyph="mic-off" size={32} />
                </Box>
              </Box>
            )}
          </Box>
          {screen && <Box className={classes.thumbnail}>{screen}</Box>}
        </Box>
      </Box>
    </Box>
  );
};

export { TopbarView };
